
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SuluMedia } from '@/logic/cms/sulu';

@Component
export default class ImageCarouselBlock extends Vue {
  @Prop(Object)
  block!: any;

  gallery = false;

  viewImages = {
    itemsToShow: 2.5,
    breakpoints: {
      768: {
        itemsToShow: 4.5,
      },
    },
  };

  $helpers: any;

  get images() {
    if (this.block && this.block.imagecarousel) {
      return this.block.imagecarousel.map(
        (images: { image: SuluMedia; type: string }) => ({
          image: this.$helpers.getApiImageThumbnail(images.image),
        }),
      );
    }
    return [];
  }

  switchGallery(value: boolean) {
    this.gallery = value;
    document.documentElement.classList.toggle('is-clipped', value);
  }
}
